<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Override Product</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-2">
  <div class="mb-3">
    <label for="hFacings" class="form-label">H Facings</label>
    <input type="number" class="form-control" id="hFacings" min="1" [(ngModel)]="productOverride.hFacings">
  </div>
  <div class="mb-3">
    <label for="vFacings" class="form-label">V Facings</label>
    <input type="number" class="form-control" id="vFacings" min="1" [(ngModel)]="productOverride.vFacings">
  </div>
  <div class="mb-3">
    <label for="dFacings" class="form-label">D Facings</label>
    <input type="number" class="form-control" id="dFacings" min="1" [(ngModel)]="productOverride.dFacings">
  </div>
  <div class="mb-3">
    <label for="categoryFlow" class="form-label">Category Flow</label>
    <input type="number" class="form-control" id="categoryFlow" min="1" [(ngModel)]="productOverride.categoryFlow">
  </div>
  <div class="mb-3">
    <label for="shelfPosition" class="form-label">Shelf Position</label>
    <select class="form-control" id="shelfPosition" [(ngModel)]="selectedShelfPosition">
      @for (index of shelfPositionKeys; track index) {
        <option [selected]="productOverride.shelfPosition == index" onChange="productOverride.shelfPosition = shelfPositionEnum[index]" [value]="index">
          {{shelfPositionEnum[index]}}
        </option>
      }
    </select>
  </div>
  <div class="mb-3">
    <label for="orientation" class="form-label">Orientation</label>
    <select class="form-control" id="orientation"  [(ngModel)]="selectedOrientation">
      @for (index of orientationKeys; track index) {
        <option [selected]="productOverride.orientation == index" onChange="productOverride.orientation = orientationEnum[index]" [value]="index">
          {{orientationEnum[index]}}
        </option>
      }
    </select>
  </div>
  <div class="mb-3">
    <label for="squeezeFactor" class="form-label">Squeeze Factor</label>
    <input type="number" class="form-control" id="squeezeFactor" min="0" max="1" [(ngModel)]="productOverride.squeezeFactor">
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="confirm()">Confirm</button>
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>